import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { BsArrowRight } from "react-icons/bs";
import { motion } from "framer-motion";

const OtherComp = () => {
  return (
    <div className="sell-music-whychoose">
      <Container>
        <Row className="align-items-center">
          <Col lg={5} className="mb-5 mb-lg-0 text-center text-lg-start">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div className="mini-title">WHY CHOOSE FTTUNES</div>
              <h2 style={{ fontSize: "36px", fontWeight: "700", color: "#fff", marginBottom: "30px", lineHeight: "1.3" }}>
                Why Choose FTtunes for Global Music Distribution?
              </h2>
              <p style={{ color: "#94a3b8", fontSize: "14px", lineHeight: "1.6", marginBottom: "20px" }}>
                At FTtunes, we understand the challenges of breaking into the
                global music market. Our platform provides everything you need to
                sell your music globally with ease and efficiency.
              </p>
              <p style={{ color: "#94a3b8", fontSize: "14px", lineHeight: "1.6", marginBottom: "40px" }}>
                By partnering with us, you gain access to an extensive network of
                digital music distribution channels, allowing your music to reach
                millions of potential fans across the globe.
              </p>
              <a
                href="https://dashboard.fttunes.com/register.php"
                target="_blank"
                rel="noopener noreferrer"
                className="btn text-white px-4 py-2 d-inline-flex align-items-center gap-2"
                style={{ borderRadius: "50px", border: "1px solid rgba(176, 66, 255, 0.5)", fontSize: "12px", fontWeight: "600", letterSpacing: "1px" }}
              >
                DISCOVER WHY <BsArrowRight size={14} />
              </a>
            </motion.div>
          </Col>
          <Col lg={7}>
            <motion.div 
              className="text-center text-lg-end"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <img
                alt="Global Music Distribution"
                loading="lazy"
                className="img-fluid"
                style={{ borderRadius: "50px", maxWidth: "100%", height: "auto" }}
                src="/Images/sell-your-music-worldwide.png"
              />
            </motion.div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default OtherComp;
